// extracted by mini-css-extract-plugin
export var details = "CruiseItineraryPrePostItem-module--details--0ca84";
export var expand = "CruiseItineraryPrePostItem-module--expand--cef3a";
export var faresBadge = "CruiseItineraryPrePostItem-module--fares-badge--efc69";
export var header = "CruiseItineraryPrePostItem-module--header--e8c0d";
export var icon = "CruiseItineraryPrePostItem-module--icon--20cb3";
export var item = "CruiseItineraryPrePostItem-module--item--6bb4b";